import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

// import const
import { BASE_URL } from 'js/constants/App';

const SiteMetaData = (props) => {
  const { title, description, keywords, og_image, og_description, og_title, og_url } = props;

  const location = useLocation();

  const parsedBaseUrl = `${BASE_URL}${location?.pathname.replace('/', '') || ''}`;

  return (
    <Helmet defer={false}>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={parsedBaseUrl} />
      <meta property="og:image:url" content={og_image} />
      <meta property="og:image" content={og_image} />
      <meta property="twitter:image" content={og_image} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={og_url !== '' ? og_url : parsedBaseUrl} />
    </Helmet>
  );
};

export default SiteMetaData;
